import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Col, Row, Card, CardBody} from 'reactstrap';
import withAuth from '../../../../components/Services/WithAuth';
import './style.css';
import OverridingRiskForm from './OverridingForm/index';
import { createOverriddingRiskFactor, overiddingRiskFactorDetails, editOverriddingRiskFactor } from './action';
import OverriddingRiskModal from '../../../../components/ReusableComponents/ModalComponent/OverriddingRiskModal/index'
import { validateOverriddingRisk, createOverriddingRiskRequestBody } from './helper'
class CreateOverridingRiskFactor extends Component {
    constructor() {
        super();
        this.state = {
            pageType: null,
            overriddingInitialValue: {
                overriddingRiskFactorName: '',
                overriddingScore: ''
            },
            validateOveriddingFactorFlag: true,
            overiddingId: null
        }
    }
    componentDidMount() {
        this.setState({
            overiddingId: this.props.match.params.overriddingId
        }, () => {
            this.props.overiddingRiskFactorDetails(this.state.overiddingId);
        })
    }
    componentDidUpdate(prevProps) {
        const { overriddingRiskFactor, overriddingRiskFactorDetails } = this.props
        if (overriddingRiskFactor !== prevProps.overriddingRiskFactor) {
            this.setState({
                validateOveriddingFactorFlag: !validateOverriddingRisk(this.props.overriddingRiskFactor.values)
            })
        }
        if (overriddingRiskFactorDetails !== prevProps.overriddingRiskFactorDetails) {
            this.setState({
                overriddingInitialValue: {
                    overriddingRiskFactorName: overriddingRiskFactorDetails.data.name,
                    overriddingScore: overriddingRiskFactorDetails.data.score
                }
            })
        }
    }
    handleSave = () => {
        const requestBody = createOverriddingRiskRequestBody(this.props.overriddingRiskFactor)
        if (!this.state.overiddingId) {
            this.props.createOverriddingRiskFactor(requestBody);
        } else {
            this.props.editOverriddingRiskFactor(requestBody, this.state.overiddingId);
        }

    }
    handleCancel = () => {
        this.props.history.push('../riskfactor/list');
    }
    modalCallBack = () => {
        if(!this.state.overiddingId){
            this.props.history.push('../riskfactor/list');
        } else {
            this.props.history.push('../list');
        }
        
    }
    render() {
        return (
            <Col>
                <Row>
                    <Col>
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h4 className="mb-0">{this.state.pageType} Overridding Risk Factor</h4>
                        </div>
                        <Card>
                            <CardBody>
                                <OverridingRiskForm initialValues={this.state.overriddingInitialValue} />
                                <Row>
                                    <Col sm="14" className="text-right">
                                        <Button outline color="primary" title="Cancel" onClick={this.handleCancel}>
                                            Cancel
                                        </Button>
                                        <Button className="ml-3" color="primary" onClick={this.handleSave} disabled={this.state.validateOveriddingFactorFlag} title="Save Overridding Risk">
                                            Save
                                        </Button>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <OverriddingRiskModal modalCallBack={this.modalCallBack} />
            </Col>
            // <div className="col">
            //     <div className="overridding-riskfactor">
                    
            //         <h3>{this.state.pageType} Overridding Risk Factor</h3>
            //         <div className="overriding-riskform" >
            //             <OverridingRiskForm initialValues={this.state.overriddingInitialValue} />
            //         </div>
            //         <div aria-label="Overridding Risk Factor Save">
            //             <Button className="m-3" outline color="danger" title="Cancel" onClick={this.handleCancel}>
            //                 <i className="fa fa-times fa-fw" aria-hidden="true"></i>&nbsp;Cancel
            //             </Button>
            //             <Button className="m-3" color="success" onClick={this.handleSave} disabled={this.state.validateOveriddingFactorFlag} title="Save Overridding Risk">
            //                 <i className="fa fa-save fa-fw" aria-hidden="true"></i>&nbsp;Save
            //             </Button>
            //         </div>
            //     </div>
            //     <OverriddingRiskModal modalCallBack={this.modalCallBack} />
            // </div>
        )
    }
}
const mapStateToProps = (state, ownProps) => ({
    overriddingRiskFactor: state.form.overriddingForm,
    overriddingRiskFactorDetails: state.overriddingRiskFactor.overriddingRiskFactorDetails
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    createOverriddingRiskFactor: (requestBody) => { dispatch(createOverriddingRiskFactor(requestBody)) },
    overiddingRiskFactorDetails: (id) => { dispatch(overiddingRiskFactorDetails(id)) },
    editOverriddingRiskFactor: (requestBody, id) => { dispatch(editOverriddingRiskFactor({ requestBody: requestBody, id: id })) }
});
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withAuth(CreateOverridingRiskFactor));
